import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_APPSEBRAE}${process.env.VUE_APP_API_PATH}/appsebrae/fornecedores/consultorias`

export default {
    obterTodasSolicitacoes() {
        return axiosJwt
            .get(`${api}/solicitacoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTodasConsultorias() {
        return axiosJwt
            .get(`${api}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterSolicitacaoPorId(consultoriaId) {
        return axiosJwt
            .get(`${api}/solicitacoes/${consultoriaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterConsultoriaPorId(consultoriaId) {
        return axiosJwt
            .get(`${api}/${consultoriaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aceitar(consultoria) {
        return axiosJwt
            .post(`${api}/solicitacoes/${consultoria.consultoriaId}/aceitar`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    naoAceitar(consultoria) {
        return axiosJwt
            .post(
                `${api}/solicitacoes/${consultoria.consultoriaId}/naoaceitar`,
                consultoria
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCondicoesContratuais() {
        return axiosJwt
            .get(`${api}/solicitacoes/condicoescontratuais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aceitarCondicoesContratuais(aceiteDto) {
        return axiosJwt
            .post(
                `${api}/solicitacoes/${aceiteDto.consultoriaId}/aceitarcondicoescontratuais`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirConsultoriaAnexo(consultoriaAnexo) {
        const formData = new FormData()
        formData.append('consultoriaId', consultoriaAnexo.consultoriaId)
        formData.append('tipoId', consultoriaAnexo.tipoId)
        formData.append('descritivo', consultoriaAnexo.descritivo)
        formData.append('arquivo', consultoriaAnexo.arquivo)

        return axiosJwt
            .post(`${api}/anexos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirConsultoriaAnexo(consultoriaAnexoId) {
        return axiosJwt
            .delete(`${api}/anexos/${consultoriaAnexoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarConsultoriaRaht(raht) {
        return axiosJwt
            .post(`${api}/raht`, raht)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarConsultoriaParaAnalise(consultoriaParaAnalise) {
        return axiosJwt
            .post(`${api}/enviarparaanalise`, consultoriaParaAnalise)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterConsultoriaAnexo(consultoriaAnexoId) {
        return axiosJwt
            .get(`${api}/anexos/${consultoriaAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comunicarConclusaoConsultoria(consultoriaConcluida) {
        return axiosJwt
            .post(`${api}/comunicarconclusao`, consultoriaConcluida)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
